/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import { html } from 'htm/preact';

// import { GameMatchTable as GMTComponent } from '../../../site/_includes/components/GameMatchTable/GameMatchTable';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import { Loader } from '@googlemaps/js-api-loader';
import Request from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import GameMatchTableClass from '../../components/GameMatchTable';

const PAGE_SIZE = 10;

class MyMatches {
	constructor() {
		this.url = '';
		this.total = 0;
		this._data = {};
		this._filters = {};
		this.page = 0;
		this.init();
	}

	set data(data) {
		this._data = data;
		this.totalCount = data.searchResultsCount;
		this.gameMatchTable.tableData = this._data;
		this.render();
	}

	set filter(filters) {
		this._filters = {
			...this._filters,
			...filters
		};
		this.fetchResults();
	}

	get filter() {
		return this._filters;
	}

	get data() {
		return this._data;
	}

	init() {
		this._wrapper = SelectorEngine.findOne('.js-lta-matches');
		this._tableWrapper = SelectorEngine.findOne('.js-lta-matches-table');
		if(!this._wrapper || !this._tableWrapper) {
			return;
		}
		this.contactId = Manipulator.getDataAttribute(this._wrapper, 'contactId');
		this.matchId = Manipulator.getDataAttribute(this._wrapper, 'matchId');
		this.viewUrl = Manipulator.getDataAttribute(this._wrapper, 'viewUrl');
		this.gameMatchTable = new GameMatchTableClass(this._tableWrapper, this.viewUrl);
		this.gameMatchTable.onChange((page) => {
			if(this.page !== page) {
				this.page = page;
				this.fetchResults(page);
			}
		});

		const filters = SelectorEngine.find('.lta-select select', this._wrapper);
		for(const filter of filters) {
			EventHandler.on(filter, 'change', this.filterChangleHandler.bind(this));
		}

		const tabs = SelectorEngine.find('.lta-tablist__tab', this._wrapper);
		for(const tab of tabs) {
			EventHandler.on(tab, 'click', this.tabChangleHandler.bind(this));
		}

		this.fetchResults();
	}

	filterChangleHandler(event) {
		const { target } = event;
		const { filterField } = Manipulator.getDataAttributes(target);
		this.filter = {
			[filterField]: target.value
		};
	}

	tabChangleHandler(event) {
		const selectedSport = SelectorEngine.findOne('.title', event.currentTarget);
		this.filter = {
			sport: selectedSport.textContent,
		};
	}

	async fetchResults(page = 0) {
		try {
			const filters = new URLSearchParams({
				"contactId": this.contactId,
				"matchId": this.matchId,
				"pageIndex": page,
				"pageSize": PAGE_SIZE,
				"timeFrame": "",
				...this.filter
			});

			// Local testing
			// const result = await fetch(`https://dev-verolt.azurewebsites.net/api/selfsubmission/getMatchResults?${filters}`);
			// Prod
			const result = await fetch(`/api/selfsubmission/getMatchResults?${filters}`);

			const response = await result.json();

			this.data = await {
				...response,
				pageIndex: page,
			};
		} catch(error) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
	}

	render() {
		this.countElement = SelectorEngine.findOne('.js-lta-matches__count span', this._tableWrapper);
		this.countElement.innerHTML = this.totalCount > 1 ? `${this.totalCount} matches` : `${this.totalCount} match`;
	}
}

const globalMyMatches = new MyMatches();
export default globalMyMatches;
